import { create } from 'zustand';
import { applyNodeChanges, applyEdgeChanges, MarkerType } from 'reactflow';

// ==================== INITIAL DATA ====================
const initialNodes = [
  {
    id: '1',
    label: '1',
    position: { x: 0, y: 0 },
    data: { label: 'Add' },
    type: 'custom',
  },
  {
    id: '2',
    label: '2',
    position: { x: 0, y: 200 },
    data: { label: 'Add' },
    type: 'custom',
  },
];

const initialEdges = [
  {
    id: '1-2',
    source: '1',
    target: '2',
    sourceHandle: 'c',
    targetHandle: 'a',
    type: 'floating',
    color: 'black',
    markerEnd: { type: MarkerType.ArrowClosed },
  },
];

// ==================== MINDMAP STORE ====================
export const useFlowchartStoreMindmap = create((set, get) => ({
  nodes: initialNodes,
  edges: initialEdges,
  title: '',
  owner: false,

  onNodesChange: (changes) => {
    set({ nodes: applyNodeChanges(changes, get().nodes) });
  },

  onEdgesChange: (changes) => {
    set({ edges: applyEdgeChanges(changes, get().edges) });
  },

  onConnect: (connection) => {
    const { source, target, sourceHandle, targetHandle } = connection;
    if (!source || !target) return;

    const edges = get().edges;
    const edgeIdExists = edges.some(
      (edge) => edge.id === `reactflow__edge-${source}-${target}`
    );

    const newEdgeId = edgeIdExists
      ? `reactflow__edge-${source}-${target}-${sourceHandle}`
      : `reactflow__edge-${source}-${target}`;

    set({
      edges: [
        ...edges,
        {
          id: newEdgeId,
          source,
          target,
          sourceHandle,
          targetHandle,
          type: 'floating',
          markerEnd: { type: MarkerType.ArrowClosed },
        },
      ],
    });
  },

  updateNodeLabel: (id, label) => {
    set({
      nodes: get().nodes.map((node) =>
        node.id === id
          ? { ...node, data: { ...node.data, label } }
          : node
      ),
    });
  },

  setNodes: (data) => set({ nodes: data }),
  setEdges: (data) => set({ edges: data }),
  setTitle: (title) => set({ title }),
  setOwner: (owner) => set({ owner }),
}));

// ==================== PRODUCTION STORE ====================
export const useFlowchartStoreProduction = create((set, get) => ({
  nodes: initialNodes,
  edges: initialEdges,
  title: '',
  owner: false,

  onNodesChange: (changes) => {
    set({ nodes: applyNodeChanges(changes, get().nodes) });
  },

  onEdgesChange: (changes) => {
    set({ edges: applyEdgeChanges(changes, get().edges) });
  },

  onConnect: (connection) => {
    const { source, target, sourceHandle, targetHandle } = connection;
    if (!source || !target) return;

    const edges = get().edges;
    const edgeIdExists = edges.some(
      (edge) => edge.id === `reactflow__edge-${source}-${target}`
    );

    const newEdgeId = edgeIdExists
      ? `reactflow__edge-${source}-${target}-${sourceHandle}`
      : `reactflow__edge-${source}-${target}`;

    set({
      edges: [
        ...edges,
        {
          id: newEdgeId,
          source,
          target,
          sourceHandle,
          targetHandle,
          type: 'floating',
          markerEnd: { type: MarkerType.ArrowClosed },
        },
      ],
    });
  },

  updateNodeLabel: (id, label) => {
    set({
      nodes: get().nodes.map((node) =>
        node.id === id
          ? { ...node, data: { ...node.data, label } }
          : node
      ),
    });
  },

  setNodes: (data) => set({ nodes: data }),
  setEdges: (data) => set({ edges: data }),
  setTitle: (title) => set({ title }),
  setOwner: (owner) => set({ owner }),
}));